export class OperationCloseDay {

    id: number;
    date: Date;
    observation: string;
}